import axios from 'axios'
import { DEFAULT_BASE_URL } from './constants.js'

const axiosInstance = axios.create({
	baseURL: DEFAULT_BASE_URL,
	timeout: 20000,
	withCredentials: true,
})

// ensure PATCH uses merge-patch+json by default
axiosInstance.defaults.headers.patch = {
	...axiosInstance.defaults.headers.patch,
	'Content-Type': 'application/merge-patch+json',
}

axiosInstance.interceptors.request.use(
	(config) => {
		if (!config.baseURL) {
			config.baseURL = DEFAULT_BASE_URL
		}
		const token = localStorage.getItem('jwtToken')
		if (token) {
			config.headers['Authorization'] = `Bearer ${token}`
		}
		return config
	},
	(error) => Promise.reject(error)
)

axiosInstance.interceptors.response.use(
	(response) => response.data, //TODO: return response!
	(error) => {
		if (error.response) {
			console.error('Response error:', error.response)
		} else if (error.request) {
			console.error('No response:', error.request)
		} else {
			console.error('Axios error:', error.message)
		}
		return Promise.reject(error)
	}
)

export default axiosInstance
